/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Ported from @material-ui/core@4.11.3
 */

import * as React from 'react';
import cx from 'classnames';
import { ButtonBase } from '../ButtonBase/ButtonBase';
import styles from './AccordionSummary.module.scss';
import { useLabel } from '@/hooks/useLabels';

export type AccordionSummaryProps = {
  /**
   * The content of the accordion summary.
   */
  children?: React.ReactNode;

  /**
   * @ignore
   */
  className?: string;
  /**
   * @ignore
   */
  contentClassName?: string;

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon?: React.ReactNode;

  /**
   * @ignore
   */
  onClick?: (event: MouseEvent) => unknown;
  expanded?: boolean;
  toggle?: (event: MouseEvent) => unknown;
  disabled?: boolean;
  title: string;
  wrapper?: 'h3' | 'span' | 'div';
  id: string;
  detailsID: string;
};

function AccordionSummary({
  children,
  className,
  contentClassName,
  expandIcon,
  onClick,
  expanded,
  toggle,
  disabled,
  title: _title,
  wrapper: Wrapper = 'h3',
  id,
  detailsID,
  ...other
}: AccordionSummaryProps) {
  const lblExpansiblePanel = useLabel('label_ShelfPage_leftSideBar_ExpansiblePanel');

  const handleChange = (event: any) => {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Wrapper>
      <ButtonBase
        component="button"
        className={cx(
          styles.root,
          {
            [styles.disabled]: disabled,
            [styles.expanded]: expanded,
          },
          className,
        )}
        id={id}
        aria-controls={detailsID}
        disabled={disabled}
        onClick={handleChange}
        aria-expanded={expanded}
        data-testid="expand-and-collapse-button"
        {...other}
        style={{ textAlign: 'left' }}
      >
        <div
          className={cx(styles.content, contentClassName, {
            [styles.expanded]: expanded,
          })}
        >
          {children}
          <span className="sr-only">{lblExpansiblePanel}</span>
        </div>
        {expandIcon && (
          <div
            className={cx(styles.expandIcon, {
              [styles.expanded]: expanded,
            })}
          >
            {expandIcon}
          </div>
        )}
      </ButtonBase>
    </Wrapper>
  );
}

export default AccordionSummary;
